
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecarrentalpune() {



    const cardData =
    {
        keyword: 'Corporate Car Rental Pune',
        heading: 'etravo : Corporate Car Rental Pune',
        headingDescription: 'eTravo offers premium Corporate Car Rental services in Pune, crafted for the specific needs of businesses, professionals, and executives. Whether you need a chauffeur-driven sedan for a client meeting, an SUV for executive travel, or a fleet for a corporate event, our services ensure style, comfort, and punctuality. With a wide range of well-maintained, GPS-enabled vehicles and trained chauffeurs, we provide flexible rental plans — hourly, daily, or monthly. eTravo’s corporate car rentals are perfect for airport transfers, business visits, and employee transport, making us the trusted mobility partner for companies across Pune’s commercial landscape.',

        top: 'Top Places to Visit in Pune with etravo',
         "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732 as the seat of the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fortification in Pune. Though much of it was destroyed in an 1828 fire, the surviving structures and gardens offer a glimpse into its grand past. The site is renowned for its architectural features and is a popular tourist attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892 by Sultan Muhammed Shah Aga Khan III, this palace played a significant role during India's freedom movement. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace now houses a museum and memorials dedicated to Gandhi and his associates."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located approximately 28 km southwest of Pune, Sinhagad Fort is a hill fortress known for the Battle of Sinhagad in 1670. The fort offers panoramic views and is a popular destination for trekking enthusiasts. It houses memorials and remnants of historical significance."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This renowned temple is dedicated to Lord Ganesha and is famous for its rich history and the grand idol adorned with gold. It attracts thousands of devotees, especially during the Ganesh Chaturthi festival."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple is carved from a single basalt rock. The temple complex includes a circular Nandi mandapa and is a protected monument under the Archaeological Survey of India."
    },
    {
      "title": "Osho International Meditation Resort",
      "description": "Situated in Koregaon Park, this meditation center offers a tranquil environment for spiritual growth and wellness. It attracts visitors worldwide seeking meditation and personal development programs."
    },
    {
      "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped garden symbolizes the Indo-Japanese friendship. It features manicured lawns, waterfalls, and a serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of artifacts showcasing India's rich cultural heritage. Exhibits include musical instruments, sculptures, and everyday objects from the 18th and 19th centuries."
    },
    {
      "title": "Koregaon Park",
      "description": "A vibrant neighborhood known for its lush greenery, upscale eateries, and cultural hubs. Koregaon Park is a popular destination for dining, shopping, and experiencing Pune's cosmopolitan lifestyle."
    },
    {
      "title": "Lal Mahal",
      "description": "Originally built in the 17th century, Lal Mahal is historically significant as the childhood residence of Chhatrapati Shivaji Maharaj. The reconstructed palace now serves as a museum showcasing Maratha history."
    }
  ],



 "services": [
  {
    "name": "Corporate Car Rental Pune",
    "description": "eTravo offers reliable and flexible corporate car rental in Pune for daily commutes, executive travel, and business operations. Our services cover the entire city, ensuring smooth and professional transportation for your workforce."
  },
  {
    "name": "Executive Car Hire Pune",
    "description": "Travel in comfort with eTravo’s executive car hire services in Pune. Ideal for senior staff and VIP clients, our fleet includes sedans and luxury cars with trained chauffeurs for meetings, conferences, and airport transfers."
  },
  {
    "name": "AC Car Rental for Corporate Travel Pune",
    "description": "Choose eTravo’s AC car rental for corporate travel in Pune for a climate-controlled, premium commute. Whether it’s daily travel or event logistics, our air-conditioned cars ensure a comfortable ride every time."
  },
  {
    "name": "Reliable Business Car Services Pune",
    "description": "eTravo provides reliable business car services in Pune to support daily operations, executive mobility, and employee transportation. Our punctual service and well-maintained vehicles guarantee smooth travel across the city."
  },
  {
    "name": "Staff Transport Car Services Pune",
    "description": "eTravo’s staff transport car services in Pune help businesses manage employee movement efficiently. Perfect for small teams or shift-based transport, we ensure timely pickup and drop with trained drivers."
  },
  {
    "name": "Monthly Corporate Car Rental Pune",
    "description": "Get cost-effective monthly corporate car rental in Pune with eTravo. Our packages are perfect for businesses seeking long-term, consistent car hire for employees, executives, and administrative travel."
  },
  {
    "name": "Customized Corporate Transport Pune",
    "description": "eTravo delivers customized corporate transport in Pune tailored to your business needs. From route planning to car types, we create flexible solutions for daily commutes, events, and client travel."
  },
  {
    "name": "Affordable Corporate Car Rentals Pune",
    "description": "eTravo offers affordable corporate car rentals in Pune without compromising on quality. Choose from budget to executive class vehicles for employee and management-level transport that fits your budget."
  },
  {
    "name": "Employee Pickup and Drop Pune",
    "description": "Ensure your employees arrive on time with eTravo’s employee pickup and drop services in Pune. We offer and dedicated car options, backed by real-time tracking and responsive support."
  },
  {
    "name": "Business Meeting Car Hire Pune",
    "description": "eTravo’s business meeting car hire in Pune provides punctual and polished transport for professionals attending meetings, seminars, and client visits across the city and nearby locations."
  },
  {
    "name": "Company-Specific Car Mobility Pune",
    "description": "With eTravo’s company-specific car mobility in Pune, you get tailor-made solutions for staff, executives, and visitor transport. We understand your unique operational needs and deliver accordingly."
  },
  {
    "name": "End-to-End Car Mobility Solutions Pune",
    "description": "From planning to tracking, eTravo’s end-to-end car mobility solutions in Pune streamline your entire transport process. Ideal for employee commutes, client transfers, and corporate logistics."
  },
  {
    "name": "Staff Movement Car Rental Pune",
    "description": "eTravo supports workforce logistics with staff movement car rental in Pune. Perfect for small teams or specific departments, our cars operate on fixed or flexible schedules with reliable service."
  },
  {
    "name": "Client Visit Car Services Pune",
    "description": "Make a great impression with eTravo’s client visit car services in Pune. Clean, comfortable, and professionally driven vehicles ensure your guests travel in style and punctuality."
  },
  {
    "name": "Professional Car Rental Services Pune",
    "description": "eTravo delivers professional car rental services in Pune for corporate use. From employee transport and executive rides to event support, we offer scalable and reliable mobility options."
  }
],
"tableData": [
  ["Corporate Car Rental Pune", "Executive Car Hire Pune"],
  ["AC Car Rental for Corporate Travel Pune", "Reliable Business Car Services Pune"],
  ["Staff Transport Car Services Pune", "Monthly Corporate Car Rental Pune"],
  ["Customized Corporate Transport Pune", "Affordable Corporate Car Rentals Pune"],
  ["Employee Pickup and Drop Pune", "Business Meeting Car Hire Pune"],
  ["Company-Specific Car Mobility Pune", "End-to-End Car Mobility Solutions Pune"],
  ["Staff Movement Car Rental Pune", "Client Visit Car Services Pune"],
  ["Professional Car Rental Services Pune", ""]
],






"whychoose": [
    {
        "WhyChooseheading": "Premium Corporate Car Rental Services in Pune",
        "WhyChoosedescription": "eTravo offers top-tier corporate car rental solutions across Pune, designed for businesses that value reliability, professionalism, and convenience. Whether it’s for client meetings, airport transfers, or executive mobility, our services are tailored to meet your corporate standards."
    },
    {
        "WhyChooseheading": "Wide Range of Cars for Corporate Use",
        "WhyChoosedescription": "Our Pune fleet includes well-maintained sedans, SUVs, luxury cars, and executive vehicles. Whether you need a single-day rental or long-term corporate car usage, we have flexible plans that adapt to your business demands."
    },
    {
        "WhyChooseheading": "On-Time Pickups and Route Flexibility",
        "WhyChoosedescription": "Punctuality is critical in the corporate world. eTravo ensures on-time pickups and smart route planning to accommodate traffic patterns across Pune’s business hubs such as Kharadi, Hinjewadi, Baner, and Magarpatta."
    },
    {
        "WhyChooseheading": "Professional Chauffeurs with Business Etiquette",
        "WhyChoosedescription": "Our drivers are background-verified, trained in corporate protocols, and fluent in local routes. From executive transfers to full-day rentals, they deliver a smooth, safe, and professional travel experience."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages for Companies",
        "WhyChoosedescription": "Whether you need daily rentals, monthly leases, or ad hoc corporate transport, eTravo provides customizable packages that fit your operational needs—perfect for companies of all sizes in Pune."
    },
    {
        "WhyChooseheading": "Transparent Pricing and GST-Compliant Billing",
        "WhyChoosedescription": "eTravo maintains complete billing transparency. We offer GST-ready invoices, consolidated monthly reports, and no hidden charges—making it simple for your admin and finance teams to track transport expenses."
    },
    {
        "WhyChooseheading": "Safe, Clean, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Every vehicle in our corporate rental fleet is thoroughly cleaned, regularly serviced, and equipped with GPS, seat belts, and emergency kits. Your employees and clients travel in comfort and safety."
    },
    {
        "WhyChooseheading": "Dedicated Support and Real-Time Tracking",
        "WhyChoosedescription": "Our 24/7 support team ensures your rental experience is seamless—from booking to ride completion. Track your vehicle in real time and contact our team anytime for urgent requests or changes."
    }
]














    }

const faqData = [
    [
        {
            question: 'What corporate car rental services does eTravo offer in Pune?',
            answer: 'eTravo provides flexible and professional corporate car rental services in Pune, ideal for executive travel, client visits, airport transfers, and day-long business trips.',
        },
        {
            question: 'Are the vehicles available for short-term and long-term rentals in Pune?',
            answer: 'Yes, eTravo offers both short-term and long-term car rental plans for corporate clients in Pune, tailored to meet daily, weekly, or monthly requirements.',
        },
        {
            question: 'What vehicle options are included in corporate rentals in Pune?',
            answer: 'Our Pune fleet includes hatchbacks, sedans, and premium SUVs — each maintained to high standards for comfort, punctuality, and executive travel needs.',
        },
        {
            question: 'Is chauffeur service included in eTravo’s corporate car rentals in Pune?',
            answer: 'Yes, all corporate car rentals in Pune come with experienced, uniformed chauffeurs trained in route management, professional etiquette, and corporate protocol.',
        },
        {
            question: 'Do corporate clients in Pune receive dedicated support?',
            answer: 'Absolutely. eTravo assigns dedicated account managers to handle scheduling, vehicle allocation, real-time adjustments, and regular performance reviews for all corporate rentals.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Arvind Mehta',
        designation: 'Facility Manager, Quantum Logic Pvt. Ltd., Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo’s corporate car rental services for our executives and client visits across Pune. Their cars are clean, drivers are professional, and scheduling is hassle-free.”',
    },
    {
        name: 'Ms. Rutuja Naik',
        designation: 'Executive Assistant, Zenith Enterprises, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s car rental services have been a great asset for our team’s business travel. They’re punctual, flexible with bookings, and offer excellent customer service.”',
    },
];













    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Car Rental Pune",
  "image": "https://www.etravo.in/images/keyword/corporate-car-rental-pune.jpg",
  "description": "Reliable corporate car rental services in Pune offering executive car hire, AC car rentals for business travel, staff transport, and customized corporate mobility solutions for companies.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-car-rental-pune"
  }
};







    return (
        <div>
<Helmet>
  <title>Corporate Car Rental Pune | Executive Car Hire & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire reliable corporate car rentals in Pune with eTravo. Executive car hire, AC business travel cars, staff transport, and customized corporate transport solutions." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/1082.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecarrentalpune;